<template>
    <b-modal
        title-tag="h2"
        title="Sign Letter"
        :lazy="true"
        :visible="isOpen"
        @ok="proceed"
    >
        <signature v-model="signature" />
        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Sign
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import Signature from "../../module/commons/signature";
import S3 from "aws-s3-pro";
import PatientDocument from "@/services/patient-documents";
import Loader from "@/module/commons/loader";
import { DateTime } from "luxon";
import { mapValues, keyBy } from "lodash";
export default {
    components: {
        Loader,
        Signature
    },
    data() {
        return {
            id: null,
            isOpen: false,
            isLoading: false,
            signature: "",
            signatures: [],
            patientLetterDetails: null
        };
    },
    methods: {
        open(params) {
            this.isOpen = true;
            this.patientLetterDetails = params;
        },
        close() {
            this.isOpen = false;
        },
        async uploadSignatures() {
            let patientId = this.patientLetterDetails.patient_id;
            let clientId = this.patientLetterDetails.client_id;
            let dirName;

            if (!patientId && !clientId) {
                this._message("Error : Unable to upload signature", "danger");
                console.error("patientId & clientId is null");
            }

            if (patientId) {
                dirName =
                    this._s3Path("patient", patientId) + "letters/signatures";
            } else {
                dirName =
                    this._s3Path("actor", clientId) + "letters/signatures";
            }

            const S3Client = new S3({
                dirName,
                bucketName: process.env.S3_BUCKET,
                region: process.env.S3_REGION,
                accessKeyId: process.env.S3_KEY,
                secretAccessKey: process.env.S3_SECRET,
                s3Url: process.env.S3_URI
            });

            const s3return = await Promise.all(
                this.signatures.map(signature => {
                    let fileName =
                        signature.id +
                        "_" +
                        Math.round(DateTime.local().toSeconds());
                    return this.dataUrlToFile(
                        signature.image,
                        fileName + ".png"
                    )
                        .then(file => {
                            return S3Client.uploadFile(file, fileName);
                        })
                        .then(() => ({
                            ...signature,
                            filename: fileName + ".png"
                        }));
                })
            );
            return mapValues(keyBy(s3return, "id"), "filename");
        },
        async dataUrlToFile(dataUrl, fileName) {
            const res = await fetch(dataUrl);
            const blob = await res.blob();
            return new File([blob], fileName, { type: "image/png" });
        },
        async saveSigniture(signatures, isUploaded) {
            let self = this;
            let data = new FormData();
            data.append("fm_signature_isUploaded", isUploaded);
            data.append(
                "fm_signature_filename",
                isUploaded == 1 ? signatures[self.patientLetterDetails.id] : ""
            );
            data.append("fm_signature_output", self.patientLetterDetails.id);
            data.append("fm_signature_name", signatures);
            data.append("fm_signature_letter_id", self.patientLetterDetails.id);
            data.append(
                "fm_signature_actor_id",
                self.patientLetterDetails.client_id
            );
            data.append(
                "fm_signature_patient_id",
                self.patientLetterDetails.patient_id
            );
            data.append("fm_signature_referrer", "letter");

            PatientDocument.saveSigniture(data).then(response => {
                if (response.state == 0) {
                    self._message(response.message);
                    this.$emit("on-success");
                    self.close();
                } else {
                    self._message(response.message, "danger");
                }
            });
        },
        async proceed() {
            let self = this;
            let signatures = null;

            if (self.signature == "" || $("#fm_credit_card_name").value == "") {
                self._message(" Please enter signature", "danger");
                return;
            }

            if (self.patientLetterDetails) {
                self.isLoading = true;

                if (self.signature) {
                    self.signatures.push({
                        id: self.patientLetterDetails.id,
                        image: self.signature
                    });

                    signatures = await self.uploadSignatures();

                    if (signatures) {
                        self.saveSigniture(signatures, 1);
                    }
                } else if ($("#fm_credit_card_name").value != "") {
                    let signName = document.getElementById(
                        "fm_credit_card_name"
                    ).value;
                    console.log(signName);
                    self.saveSigniture(signName, 0);
                }
            }
        }
    }
};
</script>
